import { render, staticRenderFns } from "./BetFilters.vue?vue&type=template&id=3f715f52"
import script from "./BetFilters.vue?vue&type=script&lang=ts"
export * from "./BetFilters.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports